import { createReducer } from "redux-create-reducer";

import {
  GET_LOGS,
  GET_LOGS_COUNT,
  SET_LOG_SEARCH_FILTERS,
  CLEAR_LOGS,
  SET_LOGS_CURRENT_PAGE,
  SET_LOGS_ITEMS_PER_PAGE,
  SET_LOGS_NO_ENTRIES_MESSAGE,
} from "../types";
import { FILTERS_TEMPLATE } from "../constants/logFilters";

const initialState = {
  data: [],
  pageInfo: {
    count: 0,
    itemsPerPage: 10,
    currentPage: 1,
  },
  filters: FILTERS_TEMPLATE,
  entries: [],
  logs: [],
  isLoading: false,
  noEntriesMessage: "",
};

const logsReducer = createReducer(initialState, {
  [SET_LOG_SEARCH_FILTERS]: (state, { payload }) => ({
    ...initialState,
    filters: { ...state.filters, ...payload },
  }),
  [SET_LOGS_CURRENT_PAGE]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      currentPage: payload,
    },
  }),
  [SET_LOGS_ITEMS_PER_PAGE]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      itemsPerPage: payload,
    },
  }),
  [GET_LOGS_COUNT.FULFILLED]: (state, { payload }) => {
    const hasResults = payload.data > 0;
    return {
      ...state,
      pageInfo: {
        ...state.pageInfo,
        count: payload.data,
      },
      isLoading: hasResults,
    };
  },
  [GET_LOGS_COUNT.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_LOGS_COUNT.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_LOGS_COUNT.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_LOGS.FULFILLED]: (state, { payload }) => ({
    ...state,
    data: payload.data,
    isLoading: false,
  }),
  [GET_LOGS.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_LOGS.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [SET_LOGS_NO_ENTRIES_MESSAGE]: (state, { payload }) => ({
    ...state,
    noEntriesMessage: payload,
  }),
  [CLEAR_LOGS]: () => initialState,
});

export default logsReducer;



// WEBPACK FOOTER //
// ./src/features/log/reducers/logsReducer.js